
import { Component, Vue } from 'vue-property-decorator';
import AdyenMerchantPanel from '@/components/smoothrPay/AdyenMerchantPanel.vue';
import { AdyenPlatformComponent } from '@/enums/SmoothrPay';

/** Adyen's payouts overview, per Smoothr Pay merchant. */
@Component({ components: { AdyenMerchantPanel } })
export default class SmoothrPayPayouts extends Vue {
  get payoutsOverview(): AdyenPlatformComponent {
    return AdyenPlatformComponent.PAYOUTS_OVERVIEW;
  }
}
